module.exports = __webpack_public_path__ + "static/media/Endpoint.cde5cb46.svg";